import React from 'react';
import { Alert, UnstyledButton } from '@mantine/core';
import PuckInlineRichText from '../../proposal/ProposalRichText/PuckInlineRichText';
import { puckArrayFieldPath } from '../../../utils/puckContentPath';
import { textRoleCss } from '../../../puck/fields/TextRolesField';
import { plainText } from '../../../utils/richTextHtml';
import { chapterError, currentChapter, formatChapterTime, orderedChapters } from './videoChapters';
import classes from './VideoChapterNavigation.module.css';

export default function VideoChapterNavigation({
  id, chapters = [], puck, duration = 0, currentTime = 0, onPlayChapter,
  layout = 'list', accent = '', textStyles, preview = false,
}) {
  const isEditing = !!puck?.isEditing;
  const valid = orderedChapters(chapters, duration);
  const active = currentChapter(valid, currentTime);
  const shown = isEditing ? chapters : valid;
  if (!shown.length) return null;

  return (
    <div
      role="group"
      aria-label="Chapitres de la vidéo"
      className={`${classes.chapters} ${layout === 'pills' ? classes.pills : classes.list}`}
      style={{ '--video-chapter-accent': accent || 'var(--mantine-primary-color-filled)' }}
    >
      {shown.map((chapter, index) => {
        const isActive = active === chapter;
        const content = (
          <>
            <span className={classes.time} style={textRoleCss(textStyles, 'time')}>{formatChapterTime(chapter.time)}</span>
            <span className={classes.title} style={textRoleCss(textStyles, 'title')}>
              {isEditing ? (
                <PuckInlineRichText
                  id={id}
                  puck={puck}
                  html={chapter.title}
                  contentPath={puckArrayFieldPath('chapters', index, 'title')}
                  placeholder="Titre du chapitre"
                  style={textRoleCss(textStyles, 'title')}
                  reducedToolbar
                />
              ) : plainText(chapter.title)}
            </span>
            {isActive && <span className={classes.playing} aria-hidden="true">▶</span>}
          </>
        );
        if (isEditing) {
          const error = chapterError(chapter, chapters, duration);
          return (
            <div key={index} className={`${classes.chapter} ${classes.editable}`}>
              {content}
              {error && <Alert className={classes.error} color="orange">{error}</Alert>}
            </div>
          );
        }
        return (
          <UnstyledButton
            key={chapter.time}
            className={classes.chapter}
            aria-current={isActive ? 'true' : undefined}
            aria-label={`${formatChapterTime(chapter.time)} — ${plainText(chapter.title)}`}
            disabled={preview || !(duration > 0)}
            onClick={() => onPlayChapter?.(chapter)}
          >
            {content}
          </UnstyledButton>
        );
      })}
    </div>
  );
}
